import Login from "./views/Login.vue";
import PasswordResetRequest from "./views/PasswordResetRequest.vue";
import ResetPassword from "./views/ResetPassword.vue";
import RequiredPasswordChange from "./views/RequiredPasswordChange.vue";

export default [
  {
    path: "/login",
    name: "login",
    meta: { layout: "simple" },
    component: Login
  },
  {
    path: "/requiredPasswordChange",
    name: "requiredPasswordChange",
    meta: { layout: "simple" },
    component: RequiredPasswordChange
  },
  {
    path: "/passwordReset",
    name: "passwordReset",
    meta: { layout: "simple" },
    component: PasswordResetRequest
  },
  {
    path: "/changePassword",
    name: "changePassword",
    meta: { layout: "simple" },
    props: true,
      component: ResetPassword
  }
];
